export const MIN_DONATION_PENCE = 100;
export const MAX_DONATION_PENCE = 50000;

export const parseDonationAmount = (value) => {
  const normalized = String(value ?? '').trim();
  if (!/^\d+(?:\.\d{1,2})?$/.test(normalized)) {
    return { amount: null, error: 'Enter an amount with no more than two decimal places.' };
  }

  const amount = Math.round(Number(normalized) * 100);
  if (amount < MIN_DONATION_PENCE) {
    return { amount: null, error: 'The minimum contribution is £1.' };
  }
  if (amount > MAX_DONATION_PENCE) {
    return { amount: null, error: 'The maximum contribution is £500.' };
  }

  return { amount, error: '' };
};
